module.exports = __webpack_public_path__ + "img/facebook-logo-mini.1add2404.svg";